<template>
  <b-card>
    <div class="select-wrapper month-selector">
      <b-form-group
        label="Show"
        label-cols
        label-for="filterProgressByMonth"
        class="forceBlock"
      >
        <b-form-select v-model="progressMonthFilter" id="filterProgressByMonth">
          <b-form-select-option :value="12">
            Last 12 Months
          </b-form-select-option>
          <b-form-select-option :value="6">
            Last 6 Months
          </b-form-select-option>
          <b-form-select-option :value="3">
            Last 3 Months
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
    </div>
    <div class="widget-content">
      <div v-if="data.length > 0">
        <div class="legend">
          <ul>
            <li>Owner</li>
            <li>Contractor</li>
          </ul>
        </div>
        <div>
          <GChart
            v-if="events"
            id="month-by-month-chart"
            type="LineChart"
            :data="data"
            :options="options"
            :events="events"
          />
        </div>
        <svg
          style="width: 0; height: 0; position: absolute"
          aria-hidden="true"
          focusable="false"
        >
          <pattern
            id="pattern-fill"
            x="0"
            y="0"
            width="20"
            height="8"
            patternUnits="userSpaceOnUse"
          >
            <rect
              x="0"
              y="0"
              width="10"
              height="4"
              style="stroke: none; fill: #c4c4c4"
            />
          </pattern>
        </svg>
      </div>
      <div v-else>No responses</div>
    </div>
  </b-card>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "ParticipationGraph",
  props: {
    data: { type: Array, default: () => [] },
  },
  components: {
    GChart,
  },
  data() {
    return {
      progressMonthFilter: 6,
      // progressMonthOptions: ['Last 12 Months', 'Last 6 Months', 'Last 3 Months'],
      options: {
        legend: { position: "none" },
        vAxis: {
          format: "percent",
          minValue: 0.0,
          maxValue: 1.0,
          gridlines: { count: 5, color: "#c4c4c4" },
          minorGridlines: { count: 0 },
          textStyle: {
            color: "#525456",
            fontName: "Poppins",
            fontSize: 12,
          },
        },
        hAxis: {
          textStyle: {
            color: "#525456",
            fontName: "Poppins",
            fontSize: 10,
          },
          minTextSpacing: 5,
          slantedText: true,
          slantedTextAngle: 40,
        },
        chartArea: {
          top: 10,
          bottom: 60,
          right: 0,
          left: 40,
        },
        tooltip: {
          isHtml: true,
          //ignoreBounds:true
        },
        // width: 410,
        height: 260,
        animation: {
          duration: 500,
          easing: "out",
          startup: true,
        },
      },
      events: null,
    };
  },
  mounted() {
    this.setEvents();
  },
  methods: {
    setEvents() {
      this.events = {
        ready: () => {
          var container = document.getElementById("month-by-month-chart");

          this.$helpers.handleAxisText(container);
          this.$helpers.handleGridlines(container);
        },
      };
    }
  },
  watch: {
    progressMonthFilter(val) {
      // console.log(val);
      this.$emit("update", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.forceBlock {
  display: inline !important;
}
</style>